import React from "react";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { DataTable } from "components/support";
import Big from "big.js";

const config = {
  identifier: "name",
  columns: [
    {
      accessor: "_id.name",
      Header: "Nome"
    },
    {
      id: "profit",
      accessor: report =>
        Big(report.profit)
          .plus(report.tips || 0)
          .plus(report.total_adding_optional || 0)
          .toFixed(2),
      Header: "Lucro",
      align: "right",
      type: "money"
    }
  ]
};
class MostProfitable extends React.Component {
  render() {
    return (
      <div>
        <Typography type="headline">Mais lucrativos</Typography>

        <Paper elevation={1}>
          <DataTable
            resultSet={this.props.result.most_profitable_products}
            config={config}
            showPagination={false}
          />
        </Paper>
      </div>
    );
  }
}
export default MostProfitable;



// WEBPACK FOOTER //
// ./src/components/app/history/dashboard/most-profitable/view.jsx